















import {Component, Prop, Vue} from 'vue-property-decorator';
import JdiContent from "@/components/JdiContent.vue"
@Component({
    components: {JdiContent}
})
export default class FutureAdjustable extends Vue {
}
